import './App.css';
import React from 'react';
import Navbar from './components/navbar/navbar.js';
import HomePage from './pages/home/home.js';
import StatusPage from './pages/status/status.js';
import RedirectsPage from './pages/redirects/redirects.js';
import WarframePage from './pages/warframe/warframe.js';
import ClashOfClansPage from './pages/clashofclans/clashofclans.js';
import LogoPage from './pages/logo/logo.js';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

function AppContent() {
  const location = useLocation();
  const isLogoPage = location.pathname === '/logo';

  return (
    <>
      {!isLogoPage && <Navbar />}
      <div className={`app-routes ${isLogoPage ? 'full-width' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route path="/redirects" element={<RedirectsPage />} />
          <Route path="/warframe" element={<WarframePage />} />
          <Route path="/clashofclans" element={<ClashOfClansPage />} />
          <Route path="/logo" element={<LogoPage />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
